/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isInteger } from 'lorautils/checkers/numbers';


const kTargetPatterns = [{
  pattern: /.*freq.*/i,
  target: 'freq',
}, {
  pattern: /.*MinDR.*/i,
  target: 'mindr',
}, {
  pattern: /.*MaxDR.*/i,
  target: 'maxdr',
}];

const guessTarget = (message) => {
  const hit = _.find(kTargetPatterns, p => p.pattern.test(message));
  if (hit) {
    return hit.target;
  }
  return 'submit';
};

const propTypes = {
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class NewChannelReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'chindex')
          .add('FE_EMPTY', 'freq')
          .add('FE_EMPTY', 'mindr')
          .add('FE_EMPTY', 'maxdr')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeChIndex = this.handleChangeChIndex.bind(this);
    this.handleChangeFreq = this.handleChangeFreq.bind(this);
    this.handleChangeMinDR = this.handleChangeMinDR.bind(this);
    this.handleChangeMaxDR = this.handleChangeMaxDR.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    let { errors } = this.state;

    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(
          sent.error.code,
          guessTarget(sent.error.message));
        this.setState({ errors });
      }
      if (sent.status === 'success') {
        const { getTxSize, getMacLog, deviceId } = nextProps;
        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  }

  handleChangeChIndex(e) {
    const chindex = e.target.value.trim();
    this.setState({ chindex });

    const { errors } = this.state;

    if (chindex === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chindex') });
      return;
    }
    if (!isInteger(chindex, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chindex') });
      return;
    }
    this.setState({ errors: errors.remove('chindex') });
  }

  handleChangeFreq(e) {
    const freq = e.target.value.trim();
    this.setState({ freq });

    const { errors } = this.state;

    if (freq === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'freq') });
      return;
    }
    if (!isInteger(freq, { min: 1000000, max: 1670000000 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'freq') });
      return;
    }
    this.setState({ errors: errors.remove('freq') });
  }

  handleChangeMinDR(e) {
    const mindr = e.target.value.trim();
    const { errors } = this.state;

    if (mindr === '') {
      this.setState({
        mindr,
        errors: errors.add('FE_EMPTY', 'mindr'),
      });
    }
    if (!isInteger(mindr, { min: 0, max: 65535 })) {
      this.setState({
        mindr,
        errors: errors.add('FE_INVALID', 'mindr'),
      });
    } else {
      this.setState({
        mindr,
        errors: errors.remove('mindr'),
      });
    }
  }

  handleChangeMaxDR(e) {
    const maxdr = e.target.value.trim();
    const { errors } = this.state;
    if (maxdr === '') {
      this.setState({
        maxdr,
        errors: errors.add('FE_EMPTY', 'maxdr'),
      });
    } else if (!isInteger(maxdr, { min: 0, max: 7 })) {
      this.setState({
        maxdr,
        errors: errors.add('FE_INVALID', 'maxdr'),
      });
    } else {
      this.setState({
        maxdr,
        errors: errors.remove('maxdr'),
      });
    }
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { chindex, freq, mindr, maxdr } = this.state;
    sendCmd(deviceId, {
      chindex,
      freq,
      mindr,
      maxdr,
    });
  }

  render() {
    const {
      sentStatus = '',
      chindex = '',
      freq = '',
      mindr = '',
      maxdr = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('chindex') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">Channel ID</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={chindex}
              placeholder={this.intlMsg.msg('newchannelreq.chindex.placeholder')}
              onChange={this.handleChangeChIndex}
            />
            <ControlTips
              show={submitted && errors.has('chindex')}
              message={this.intlMsg.errorMsg(errors.get('chindex'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('freq') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">Frequency</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={freq}
              placeholder={this.intlMsg.msg('newchannelreq.freq.placeholder')}
              onChange={this.handleChangeFreq}
            />
            <ControlTips
              show={submitted && errors.has('freq')}
              message={this.intlMsg.errorMsg(errors.get('freq'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('mindr') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">Min DR</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={mindr}
              placeholder={this.intlMsg.msg('newchannelreq.mindr.placeholder')}
              onChange={this.handleChangeMinDR}
            />
            <ControlTips
              show={submitted && errors.has('mindr')}
              message={this.intlMsg.errorMsg(errors.get('mindr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('maxdr') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">Max DR</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={maxdr}
              placeholder={this.intlMsg.msg('newchannelreq.maxdr.placeholder')}
              onChange={this.handleChangeMaxDR}
            />
            <ControlTips
              show={submitted && errors.has('maxdr')}
              message={this.intlMsg.errorMsg(errors.get('maxdr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => {
                  this.setState({
                    sentStatus: '',
                    errors: this.state.errors.remove('submit'),
                  });
                },
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

NewChannelReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendNewChannelReq,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendNewChannelReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NewChannelReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/NewChannelReq.jsx